export default __webpack_public_path__ + "static/Nail2-0d1116a68e6c7730659f35deeb70f69c.png";